import React from 'react';
import Icon from '../../icon';
import { faEllipsisH } from '../../icon/sets/regular';
import StyledIcon from './PageSeparator.styles';

var PageSeparator = function PageSeparator() {
  return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(Icon, {
    icon: faEllipsisH
  }));
};

export default PageSeparator;